/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductCarousel_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
    readonly " $refType": "ProductCarousel_item";
};
export type ProductCarousel_item$data = ProductCarousel_item;
export type ProductCarousel_item$key = {
    readonly " $data"?: ProductCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductCarousel_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProductCarousel_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "photosLimit",
      "type": "Int",
      "defaultValue": 2
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProductSwiper_item",
      "args": [
        {
          "kind": "Variable",
          "name": "photosLimit",
          "variableName": "photosLimit"
        }
      ]
    }
  ]
};
(node as any).hash = '848674337c12e28c1dd3bc04f3ca5bf5';
export default node;
